import { bff, createBFFHandlers } from '~/framework/bff';
import { getServerSideMonolithClient } from '~/framework';
import { GetQuizzesOptions, getQuizzes } from '~/monolith-api';

const PAGE_SIZE = 20;

export default createBFFHandlers({
   post: async (req, res) => {
      const monolithClient = getServerSideMonolithClient(req);
      const result = await getQuizzes({ apiClient: monolithClient, ...req.body });
      res.status(200).json(result);
   },
});

export const getAllSurveyJsQuizzes = (
   options?: GetQuizzesOptions,
   page?: number
): ReturnType<typeof getQuizzes> => {
   const limit = options?.limit ?? PAGE_SIZE;
   // the backend expects 'offset' to mean 'page' due to bug in implementation
   const offset = page;

   return bff()
      .post('/quizzes/getQuizzes', {
         offset,
         limit,
         ...options,
      })
      .then(response => response.data);
};
